import { forwardRef, ReactNode } from 'react'

import { SnippetCarouselContext } from './context'
import { SnippetCarousel } from './snippet-carousel'
import { useSnippetCarousel } from './use-snippet-carousel'

export interface SnippetCarouselProviderProps {
  children: ReactNode
  maxItemWidth: number
  offsetScroll?: number
  className?: string
  onArrowClick?: (direction: 1 | -1) => void
  onActivePageIndex?: (activePageIndex: number) => void
  __parentWrapperTestMode?: boolean
}

export const SnippetCarouselProvider = forwardRef<HTMLDivElement, SnippetCarouselProviderProps>(
  function SnippetCarouselProvider(props, forwardedRef) {
    const { children } = props
    const carousel = useSnippetCarousel()

    return (
      <SnippetCarouselContext.Provider value={carousel}>
        <SnippetCarousel {...props} ref={forwardedRef}>
          {children}
        </SnippetCarousel>
      </SnippetCarouselContext.Provider>
    )
  }
)
